<header class="header" id="header">
  <div class="header__top">
    <mono-common-header-user-links
    *ngIf="signInLinkPath && registrationLinkPath && !hideUserLinks"
    [language]="language"
    [signInLinkPath]="signInLinkPath"
    [registrationLinkPath]="registrationLinkPath"
    [editMyDetailsLinkPath]="editMyDetailsLinkPath"
    [previousUrl]="previousUrl"
    data-test="mono-common-header-user-links"
    ></mono-common-header-user-links>
  </div>
  <div class="grid-container header__bottom">
    <div class="grid-x align-middle align-justify">
      <div class="header__logo">
        <ng-content select="[headerLogo]"></ng-content>
      </div>
      <div
        class="reveal-overlay reveal-overlay--mobile-menu"
        [ngClass]="showMobileMenu ? 'show' : ''"
        aria-hidden="true"
        (click)="toggleMenu()"
      ></div>
      <nav
        class="header__menu-links show-for-tablet-portrait"
        [attr.aria-label]="ariaLabelMainNav ? ariaLabelMainNav : 'Main navigation'"
        [ngClass]="showMobileMenu ? 'show header__menu-links--mobile' : ''"
      >
        <ul [attr.aria-live]="isMobile ? 'polite' : 'off'"
          class="no-bullet margin-bottom-0 flex-container"
          [ngClass]="showMobileMenu ? 'flex-dir-column' : 'align-middle'"
        >
          <ng-content select="[mainNavigation]"></ng-content>
        </ul>
      </nav>
      <nav
        [attr.aria-label]="ariaLabelMobileNav ? ariaLabelMobileNav : 'Help and mobile menu opener'"
      >
        <ul class="no-bullet align-middle margin-0 flex-container">
          <ng-content select="[extraNavigation]"></ng-content>
          <li class="hide-for-tablet-portrait position-static">
            <button
              #burgerButton
              type="button"
              class="button square hollow button--mobile-menu"
              [ngClass]="
                !showMobileMenu
                  ? 'flex-dir-column button--icon-on-top'
                  : 'border-transparent'
              "
              (click)="toggleMenu()"
              [attr.aria-label]="
                showMobileMenu ?
                (ariaLabelBurgerButtonHide ? ariaLabelBurgerButtonHide : 'Exit the menu') :
                (ariaLabelBurgerButtonShow ? ariaLabelBurgerButtonShow : 'Show the menu')"
            >
              <svg
                aria-hidden="true"
                *ngIf="!showMobileMenu"
                class="icon icon--hamburger icon--primary icon--material"
                viewBox="0 0 24 24"
              >
                <use xlink:href="#icon-hamburger" href="#icon-hamburger"></use>
              </svg>
              <svg
                aria-hidden="true"
                *ngIf="showMobileMenu"
                class="icon icon--exit icon--primary icon--material"
                viewBox="0 0 24 24"
              >
                <use xlink:href="#icon-exit" href="#icon-exit"></use>
              </svg>
              <div
                *ngIf="!showMobileMenu"
                aria-hidden="true"
                class="icon-text"
              >
                {{ burgerMenuText }}
              </div>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>
